import takeRequest from '~/store/takeRequest';
import * as InsuranceActions from './actions';

export function* insuranceSaga() {
  yield takeRequest(InsuranceActions.getCancellableInsuranceContracts);
  yield takeRequest(InsuranceActions.cancelInsuranceContract);
}
